<template>
  <div class="row">
    <!-- Order Specific Timesheet Authorisation -->
    <div class="col-12">
      <b-card header="Order Timesheet Authorisation" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <!-- Display current order timesheet authorisations -->
        <div class="row" v-if="!hasContacts">
          <div class="col-xl-8 form-group">
            <h5>No contacts available for timesheet authorization. Please add new contact in company record page.</h5>
          </div>
        </div>
        <div class="row" v-if="hasContacts && notEmptyObject(default_timesheet_auth) && !edit_ts_auth">
          <div class="col-xl-6 form-group">
            <h5>Order Timesheet Authorisation and Submission Contacts</h5>
          </div>
          <div class="col-xl-6 form-group" v-if="can_edit_ts_auth">
            <button @click.prevent="edit_levels" class="btn orcaBtn sm_btn blue_btn float-right ml-3">Edit Levels</button>
            <button @click.prevent="set_level_default" class="btn orcaBtn sm_btn grey_bg float-right">Set levels to default</button>
          </div>

          <!-- Timesheet submitters listed -->
          <div class="col-12">
            <h5 class="bp_color">Contacts with permission to Submit Timesheet Instructions to <span v-if="crmType === 'payroll'">Genius Money</span><span
                v-else-if="crmType === 'recruitment'">V3 Recruitment</span> for this Order</h5>
          </div>
          <div class="col-xl-4 form-group" v-for="ts_as in default_timesheet_auth" v-if="ts_as.submission_level >= 8">
            <h5 class="font-weight-bold pt-0 mb-0">{{ ts_contact_full_name(ts_as) }}</h5>
            <p class="b3_color pt-0">{{ ts_contact_job_title(ts_as) }}</p>
            <hr class="mt-2 mb-2">

            <div class="contact_login_text">
              <div class="cardLabel">Contact has login:
                <span v-if="ts_contact_has_login(ts_as)" class="green_color">Yes</span>
                <span v-else-if="ts_contact_disabled_login(ts_as)" class="orange_color">Disabled</span>
                <span v-else class="red_color">No</span>
              </div>
            </div>
            <!-- view/enable login/create login buttons -->
            <div class="contact_login_btn" v-if="can_edit_ts_auth">
              <button v-if="ts_contact_has_login(ts_as)" @click.prevent="view_contact_login(ts_as.contact)" class="btn orcaBtn greenBtn sm_btn">View</button>
              <button v-else-if="ts_contact_disabled_login(ts_as)" @click.prevent="enable_contact_login(ts_as.contact)" class="btn orcaBtn greenBtn sm_btn">Enable</button>
              <button v-else-if="user_can_create_ts_contact_login(ts_as)" @click.prevent="create_contact_login(ts_as.contact, ts_as.submission_level)" class="btn orcaBtn sm_btn">
                Create
              </button>
            </div>
          </div>

          <!-- Timesheet authorisers listed -->
          <div class="col-12 form-group" v-if="submission_auth_as_well">
            <hr>
            <h5 class="bp_color">Contacts with permission to Authorise Timesheet Instructions for this Order</h5>
          </div>
          <div class="col-12 form-group" v-for="ts_as in default_timesheet_auth" v-if="ts_contact_is_authoriser(ts_as)">

            <div class="row">
              <div class="col-xl-4"><strong class="cardLabel">Authorising Contact Level {{ ts_contact_authorising_level(ts_as) }}</strong></div>
              <div class="col-xl-4">
                <h5 class="font-weight-bold pt-0 mb-0">{{ ts_contact_full_name(ts_as) }}</h5>
                <p class="b3_color pt-0">{{ ts_contact_job_title(ts_as) }}</p>
              </div>
              <div class="col-xl-4">
                <div class="contact_login_text">
                  <div class="cardLabel">Contact has login:
                    <span v-if="ts_contact_has_login(ts_as)" class="green_color">Yes</span>
                    <span v-else-if="ts_contact_disabled_login(ts_as)" class="orange_color">Disabled</span>
                    <span v-else class="red_color">No</span>
                  </div>
                </div>
                <!-- view/enable login/create login buttons -->
                <div class="contact_login_btn" v-if="can_edit_ts_auth">
                  <button v-if="ts_contact_has_login(ts_as)" @click.prevent="view_contact_login(ts_as.contact)" class="btn orcaBtn greenBtn sm_btn">View</button>
                  <button v-else-if="ts_contact_disabled_login(ts_as)" @click.prevent="enable_contact_login(ts_as.contact)" class="btn orcaBtn greenBtn sm_btn">Enable</button>
                  <button v-else-if="user_can_create_ts_contact_login(ts_as)" @click.prevent="create_contact_login(ts_as.contact, ts_as.submission_level)"
                          class="btn orcaBtn sm_btn">
                    Create
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- timesheet authorisation edit form -->
        <div class="row" v-if="(!notEmptyObject(default_timesheet_auth) || edit_ts_auth) && can_edit_ts_auth">
          <div class="col-12">
            <h4 class="red_color text-uppercase">This company requires setup of default contacts for Timesheet Authorisation and submission to <span
                v-if="crmType === 'payroll'">Genius</span><span v-else-if="crmType === 'recruitment'">V3</span>.</h4>
            <hr>
          </div>
          <div class="col-12">
            <ValidationObserver ref="editTSauthForm" slim>
              <form role="form" @submit.prevent="">
                <!-- submitting contacts -->
                <div class="row">
                  <div class="col-12 form-group">
                    <h5>The following contacts can Create & Amend timesheet instructions for a worker and also Submit to <span v-if="crmType === 'payroll'">Genius</span><span
                        v-else-if="crmType === 'recruitment'">V3</span> for invoicing.</h5>
                  </div>

                  <div v-for="(c, i) in ts_auth.submit_ts" class="col-xl-4 form-group ts_auth_submit" :class="{ first: i===0 }">
                    <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Submitting Contact' + (i + 1)" tag="div" class="ts_auth_submit_multi">
                      <label class="form-label" :for="'submit_ts_contact_' + i">Submitting Contact {{ i + 1 }}</label>
                      <multiselect v-model="c.contact" placeholder="" :id="'submit_ts_contact_' + i" track-by="id" :options="ms_opts.ts_contacts"
                                   :option-height="200" :show-labels="false" class="requiredField" :class="classes" @input="select_ts_contact">
                        <template slot="singleLabel" slot-scope="props">
                          <span class="option__desc_single">
                            <span class="option__title">{{ ts_contact_multiselect_full_name(props) }}</span>
                          </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                            <span class="option__title">{{ ts_contact_multiselect_full_name(props) }}</span>
                            <span class="option__small">{{ ts_contact_multiselect_job_title(props) }}</span>
                          </div>
                        </template>
                      </multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <button @click.prevent="remove_ts_auth_submitting_contact('Submitting Contact ' + (i + 1), i, c.id)"
                            class="btn orcaBtn danger text-center float-right" v-if="i !== 0">X
                    </button>
                  </div>

                  <!-- adding submitting level contact -->
                  <div v-if="show_can_add_ts_submitter_btn" class="col-12">
                        <button @click.prevent="add_ts_auth_submitting_contact" class="btn btn-success">
                            <i class="fa fa-plus"></i> Add Submitting Contact
                        </button>
                  </div>

                </div>
                <!-- authorising contacts -->
                <div class="row">
                  <div class="col-12 form-group">
                    <hr>
                    <h5>The following are contacts who can Create & Amend timesheet instructions for a worker, they authorise an instruction for the contact on the next level
                        or for a contact who can submit to Genius for invoicing.</h5>
                  </div>

                  <div v-for="(c, i) in ts_auth.authorising_ts" class="col-12 form-group">
                    <div class="row">
                      <div class="col-xl-5">
                        <p class="cardLabel pt-0">Authorising Contact Level {{ i + 1 }}</p>
                      </div>
                      <div class="col-xl-4 form-group">
                        <ValidationProvider rules="" v-slot="{errors, classes}" :name="'Authorising Contact' + (i + 1)" tag="div" class="ts_auth_submit_multi">
                          <label class="form-label" :for="'authorise_ts_contact_' + i">Authorising Contact {{ i + 1 }}</label>
                          <multiselect v-model="c.contact" placeholder="" :id="'authorise_ts_contact_' + i" track-by="id" :options="ms_opts.ts_contacts"
                                       :option-height="200" :show-labels="false" class="requiredField" :class="classes" @input="select_ts_contact">
                            <template slot="singleLabel" slot-scope="props">
                              <span class="option__desc_single">
                                 <span class="option__desc_single">
                                   <span class="option__title">{{ ts_contact_multiselect_full_name(props) }}</span>
                                 </span>
                              </span>
                            </template>
                            <template slot="option" slot-scope="props">
                              <div class="option__desc">
                                <span class="option__title">{{ ts_contact_multiselect_full_name(props) }}</span>
                                <span class="option__small">{{ ts_contact_multiselect_job_title(props) }}</span>
                              </div>
                            </template>
                          </multiselect>
                          <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </div>
                      <div class="col-xl-3 form-group">
                        <button @click.prevent="remove_ts_auth_authorising_contact('Authorising Contact ' + (i + 1), i, c.id)" class="btn orcaBtn danger">Remove</button>
                      </div>
                    </div>
                  </div>
                  <!-- adding authorising level contact -->
                  <div class="col-12" v-if="show_can_add_ts_authoriser_btn">
                    <div class="row">
                      <div class="col-xl-5">
                        <p class="cardLabel pt-0">Authorising Contact Level {{ ts_auth.authorising_ts.length + 1 }}</p>
                      </div>
                      <div class="col-xl-4 form-group">
                        <button @click.prevent="add_ts_auth_authorising_contact" class="btn btn-success">
                          <i class="fa fa-plus"></i> Add Authorising Contact
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- save order timesheet authorisation -->
                <div class="row">
                  <div class="col-12">
                    <hr>
                  </div>
                  <div class="col-xl-6 offset-xl-6 form-group">
                    <button @click.prevent="edit_ts_auth_submit" class="btn orcaBtn" type="submit" :disabled="saving_ts_auth">
                      <span v-if="saving_ts_auth"><i class="fas fa-spinner fa-spin"></i> Saving Order Authorisation & Submission ...</span>
                      <span v-else>Save Order Authorisation & Submission</span>
                    </button>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </b-card>
    </div>

    <!-- VIEW CONTACT LOGIN MODAL -->
    <view_contact_login_modal v-if="$store.state.timesheets.view_login_modal"></view_contact_login_modal>
    <!-- CREATE CONTACT LOGIN MODAL -->
    <create_contact_login_modal v-if="$store.state.timesheets.create_login_modal"></create_contact_login_modal>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
//modals
import view_contact_login_modal from "partials/modals/contacts/contact_login_view";
import create_contact_login_modal from "partials/modals/contacts/contact_login_create";
import datatable_client_logins from "datatables/datatable_client_logins";

export default {
  name: "order_timesheet_auth",
  components: {
    Multiselect,
    view_contact_login_modal,
    create_contact_login_modal
  },
  props: ['order_job', 'default_timesheet_auth', 'contacts', 'company'],
  data() {
    return {
      ms_opts: {
        ts_contacts: this.contacts
      },

      edit_ts_auth: false, // triggers show of edit form for authorisations
      saving_ts_auth: false,
      ts_auth: {
        authorising_ts: [],
        submit_ts: [
          {contact: null}
        ]
      },

      login_contacts: [],
    }
  },
  beforeMount() {
    // Timesheet authentification
    if (this.notEmptyObject(this.default_timesheet_auth)) {
      this.ts_auth.submit_ts = [];
      this.ts_auth.authorising_ts = [];
      for (let i = 0; i < this.default_timesheet_auth.length; i++) {
        if (this.default_timesheet_auth[i].submission_level >= 8) {
          this.ts_auth.submit_ts.push(this.default_timesheet_auth[i])
        }
        else {
          this.ts_auth.authorising_ts.push(this.default_timesheet_auth[i])
        }
      }
      this.calc_ts_contacts_in_multiselect();
    }
  },
  computed: {
    /**
     * Is the user able to edit timesheet authorisations levels for the order
     * @returns {boolean}
     */
    can_edit_ts_auth() {
      return !this.$store.state.auth.me.roles.includes('client_sub') && !this.$store.state.auth.me.roles.includes('client_auth')
    },
    /**
     * Are there authoriser users set up for this order's timesheet authorisation
     * @returns {boolean}
     */
    submission_auth_as_well() {
      let check = false;
      for (let i = 0; i < this.default_timesheet_auth.length; i++) {
        if (this.default_timesheet_auth[i].submission_level >= 2 && this.default_timesheet_auth[i].submission_level <= 7) {
          check = true;
        }
      }
      return check;
    },
    /**
     * Check if there is a multiselect for choosing a submitting contact that doesn't have a contact currently selected
     * (empty multiselect)
     * @returns {boolean}
     */
    check_submit_ts_contact_null() {
      let check = false;
      for (let i = 0; i < this.ts_auth.submit_ts.length; i++) {
        if ((i + 1) === this.ts_auth.submit_ts.length) {
          if (this.ts_auth.submit_ts[i].contact !== null) {
            check = true;
          }
        }
      }
      return check;
    },
    /**
     * whether the 'add submitting contact' button is visible or not
     * @returns {boolean}
     */
    show_can_add_ts_submitter_btn() {
      return this.ms_opts.ts_contacts.length > 0 && this.check_submit_ts_contact_null
    },
    /**
     * whether the 'add authorising contact' button is visible or not
     * @returns {boolean}
     */
    show_can_add_ts_authoriser_btn() {
      return this.ms_opts.ts_contacts.length > 0 && this.check_submit_ts_contact_null
    },
    hasContacts() {
      return this.contacts.length > 0;
    }
  },
  methods: {
    /**
     * function to set the order to company defaults
     */
    set_level_default() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Set order timesheet users to company default</div>' +
            '<div class="snotifyToast__body">' +
            'Confirm that you want to set this orders timesheet submitters and authorisers to the company default.' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Ok', action: (toast) => {
              axios.post(this.crmApiPath + 'timesheet_authorisation/order_job/set_as_default', {
                order_job_id: this.order_job.id,
                company_id: this.company.id,
                log_by_type: 'App\\Models\\Users\\User',
                log_by_id: this.$store.state.auth.me.id
              }).then(() => {
                this.$snotify.remove(toast.id);
                this.$tabs.refresh('/order/view', true);
              })
            }
          },
          {text: 'Cancel', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      })
    },
    /**
     * Switch from viewing to editing timesheet authorisations
     * Show form
     */
    edit_levels() {
      this.edit_ts_auth = true;
    },
    /*
     * ******************************************
     * Timesheet authorisation view existing
     * ******************************************
     */
    /**
     * Format timesheet submitter/authoriser contact name
     * @param ts_as
     * @returns {string}
     */
    ts_contact_full_name(ts_as) {
      return ts_as.contact.person.first_name + ' ' + ts_as.contact.person.surname
    },
    /**
     * If timesheet submitter/authoriser contact has job title, return job title
     * @param ts_as
     * @returns {string|*}
     */
    ts_contact_job_title(ts_as) {
      return ts_as.contact.rel_profile.job_title_id !== null ? ts_as.contact.rel_profile.job_title.job_title : "";
    },
    /**
     * If timesheet submitter/authoriser contact has a user login
     * @param ts_as
     * @returns {false}
     */
    ts_contact_has_login(ts_as) {
      return (ts_as.contact.user !== null && Object.keys(ts_as.contact.user).length > 1) && ts_as.contact.user.active
    },
    /**
     * If timesheet submitter/authoriser contact has a login but it is disabled
     * @param ts_as
     * @returns {boolean}
     */
    ts_contact_disabled_login(ts_as) {
      return (ts_as.contact.user !== null && Object.keys(ts_as.contact.user).length > 1) && !ts_as.contact.user.active
    },
    /**
     * ORCA user has the permission to create a user login to a timesheet submitter/authoriser
     * @param ts_as
     * @returns {false|*}
     */
    user_can_create_ts_contact_login(ts_as) {
      return (ts_as.contact.user === null || Object.keys(ts_as.contact.user).length === 1)
          && (this.$store.state.auth.me.roles.includes('admin') || this.$store.state.auth.me.roles.includes('manager'))
    },
    /**
     * check if a timesheet portal user contact is an authoriser by submission level
     * @param ts_as
     * @returns {boolean}
     */
    ts_contact_is_authoriser(ts_as) {
      return ts_as.submission_level >= 2 && ts_as.submission_level <= 7
    },
    /**
     * return formatted authorising level for timesheet user
     * @param ts_as
     * @returns {number}
     */
    ts_contact_authorising_level(ts_as) {
      return ts_as.submission_level - 1
    },
    /*
     * ******************************************
     * Timesheet authorisation view buttons
     * ******************************************
     */
    /**
     * Open create a contact login modal
     * @param contact
     * @param contact_sub_level
     */
    create_contact_login(contact, contact_sub_level) {
      this.$store.commit('SHOW_CREATE_CONTACT_LOGIN_MODAL', {
        contact: contact,
        contact_level: contact_sub_level
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'create_contact_login_modal'));
    },
    /**
     * open a modal to view a contact's login information (not password)
     * @param contact
     */
    view_contact_login(contact) {
      this.$store.commit('SHOW_VIEW_CONTACT_LOGIN_MODAL', {
        contact: contact
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_contact_login_modal'));
    },
    /**
     * trigger enabling a disabled contact login - this is for the user level
     * so even if they have permissions at company level or another custom order_job it will be re-enabled
     * @param contact
     */
    enable_contact_login(contact) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm Enable User Login</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure that you wish to enable this users login:<br><br>' + contact.full_name +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$snotify.remove(toast.id);

              let enable_user = {
                id: contact.user.id,
                disabled: false
              };

              axios.patch(this.crmApiPath + 'user/contact/enable/' + contact.user.id, enable_user).then(() => {
                this.$nextTick(() => {
                  // this.$bus.$emit('default_company_ts_auth::reload', {action: true});
                  this.$tabs.refresh('/order/view', true);
                  this.$bus.$emit('contacts::reload', {type: 'contact', action: true});
                })
              })
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },
    /*
     * ******************************************
     * Timesheet authorisation edit form
     * ******************************************
     */
    /**
     * Format timesheet contact multiselect option full name
     * @param props
     * @returns {string}
     */
    ts_contact_multiselect_full_name(props) {
      return props.option.person.first_name + " " + props.option.person.surname
    },
    /**
     * return timesheet contact multiselect option job title if one exists
     * @param props
     * @returns {string|*}
     */
    ts_contact_multiselect_job_title(props) {
      return props.option.rel_profile.job_title_id !== null ? props.option.rel_profile.job_title.job_title : "";
    },
    /**
     * Multiselect - select a contact from options - remove/add contact back into options
     */
    select_ts_contact() {
      this.calc_ts_contacts_in_multiselect();
      this.$nextTick(() => {
        if (this.ms_opts.ts_contacts.length === 0) {
          for (let i = 0; i < this.ts_auth.submit_ts.length; i++) {
            this.ts_auth.submit_ts = this.ts_auth.submit_ts.filter(item => item.contact !== null)
          }
          for (let i = 0; i < this.ts_auth.authorising_ts.length; i++) {
            this.ts_auth.authorising_ts = this.ts_auth.authorising_ts.filter(item => item.contact !== null)
          }
        }
      });
    },
    /**
     * Recalculate available contacts to select from multiselect
     * Based on those already selected and available from the companies contact list
     */
    calc_ts_contacts_in_multiselect() {
      this.ms_opts.ts_contacts = this.contacts;
      for (let i = 0; i < this.ts_auth.submit_ts.length; i++) {
        if (this.ts_auth.submit_ts[i].contact !== null) {
          this.ms_opts.ts_contacts = this.ms_opts.ts_contacts.filter(obj => obj.id !== this.ts_auth.submit_ts[i].contact.id)
        }
      }
      for (let i = 0; i < this.ts_auth.authorising_ts.length; i++) {
        if (this.ts_auth.authorising_ts[i].contact !== null) {
          this.ms_opts.ts_contacts = this.ms_opts.ts_contacts.filter(obj => obj.id !== this.ts_auth.authorising_ts[i].contact.id)
        }
      }
    },
    /*
     * ==== Timesheet submitter ====
     */
    /**
     * Remove a submitting contact from edit form (remove submitter for order_job)
     * @param submitting_contact
     * @param index
     * @param id
     */
    remove_ts_auth_submitting_contact(submitting_contact, index, id) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm Delete Contact</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure that you wish to remove the client timesheet submitting contact:<br><br>' + submitting_contact +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              // if there are no default timesheet authorisations set up for the company
              if (!this.notEmptyObject(this.default_timesheet_auth)) {
                this.$snotify.remove(toast.id)
                // splice contact from array
                this.ts_auth.submit_ts.splice(index, 1)
                // recalculate available contacts for multiselect's
                this.calc_ts_contacts_in_multiselect()
              }
              else {
                // if the contact exists as a saved timesheet submitter already (from database get)
                if (id !== undefined) {
                  // delete the timesheet authorisations record for the contact being removed
                  axios.delete(this.crmApiPath + 'timesheet_authorisation/order_job/' + id, {
                    params: {
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    }
                  }).then(other_auths => {
                    // if the timesheet authorisation submitter contact has an ORCA user delete this user
                    // AND isn't on any other company or order_job timesheet authorisations
                    if (this.ts_auth.submit_ts[index].contact.user !== null && Object.keys(this.ts_auth.submit_ts[index].contact.user).length > 1
                    && other_auths.data.length === 0) {
                      // delete the contacts ORCA user
                      axios.delete(this.crmApiPath + 'user/contact/delete/' + this.ts_auth.submit_ts[index].contact.user.id).then(() => {
                        this.$snotify.remove(toast.id);
                        this.ts_auth.submit_ts.splice(index, 1);
                        this.$nextTick(() => {
                          this.calc_ts_contacts_in_multiselect();
                        })
                      });
                    }
                    // else the timesheet authorisation submitter contact doesn't have a user in ORCA
                    else {
                      this.$snotify.remove(toast.id);
                      this.ts_auth.submit_ts.splice(index, 1);
                      this.$nextTick(() => {
                        this.calc_ts_contacts_in_multiselect();
                      })
                    }
                  });
                }
                // if the contact being added is not a stored timesheet authoriser (added and removed in same edit)
                else {
                  this.$snotify.remove(toast.id);
                  // splice contact from array
                  this.ts_auth.submit_ts.splice(index, 1);
                  // recalculate available contacts for multiselect's
                  this.$nextTick(() => this.calc_ts_contacts_in_multiselect())
                }
              }
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },
    /**
     * Add a space to select another submitter for the order_job timesheet authorisations
     */
    add_ts_auth_submitting_contact() {
      this.ts_auth.submit_ts.push({contact: null});
      this.calc_ts_contacts_in_multiselect();
    },
    /*
     * ==== Timesheet authoriser ====
     */
    /**
     * Remove an authorising contact from edit form (remove authoriser for order_job)
     * @param authorising_contact
     * @param index
     * @param id
     */
    remove_ts_auth_authorising_contact(authorising_contact, index, id) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm Delete Contact</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure that you wish to remove the client timesheet authorising contact:<br><br>' + authorising_contact +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              // if there are no default timesheet authorisations already set up
              if (!this.notEmptyObject(this.default_timesheet_auth)) {
                this.$snotify.remove(toast.id)
                // splice contact from array
                this.ts_auth.authorising_ts.splice(index, 1)
                // recalculate available contacts for multiselect's
                this.calc_ts_contacts_in_multiselect()
              }
              else {
                // if the contact exists as a saved timesheet authoriser already (from database get)
                if (id !== undefined) {
                  // delete the timesheet authorisations record for the contact being removed
                  axios.delete(this.crmApiPath + 'timesheet_authorisation/order_job/' + id, {
                    params: {
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    }
                  }).then(other_auths => {
                    // if the timesheet authorisation submitter contact has an ORCA user delete this user
                    // AND isn't on any custom order timesheet authorisations
                    if (this.ts_auth.authorising_ts[index].contact.user !== null && Object.keys(this.ts_auth.authorising_ts[index].contact.user).length > 1
                        && other_auths.data.length === 0) {
                      // delete the contacts ORCA user
                      axios.delete(this.crmApiPath + 'user/contact/delete/' + this.ts_auth.authorising_ts[index].contact.user.id).then(() => {
                        this.$snotify.remove(toast.id);
                        this.ts_auth.authorising_ts.splice(index, 1);
                        this.$nextTick(() => this.calc_ts_contacts_in_multiselect())
                      });
                    }
                    // else the timesheet authorisation submitter contact doesn't have a user in ORCA
                    else {
                      this.$snotify.remove(toast.id);
                      this.ts_auth.authorising_ts.splice(index, 1);
                      this.$nextTick(() => this.calc_ts_contacts_in_multiselect())
                    }
                  })
                }
                // if the contact being added is not a stored timesheet authoriser (added and removed in same edit)
                else {
                  this.$snotify.remove(toast.id);
                  this.ts_auth.authorising_ts.splice(index, 1);
                  this.$nextTick(() => this.calc_ts_contacts_in_multiselect())
                }
              }
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },
    /**
     * Add a space to select another authoriser for the order_job timesheet authorisations
     */
    add_ts_auth_authorising_contact() {
      this.ts_auth.authorising_ts.push({contact: null});
      this.calc_ts_contacts_in_multiselect();
    },
    /*
     * ******************************************
     * Timesheet edit form submission
     * ******************************************
     */
    edit_ts_auth_submit() {
      this.$refs.editTSauthForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.editTSauthForm);
        }
        else {
          this.saving_ts_auth = true;
          axios.post(this.crmApiPath + 'timesheet_authorisation/order_job/set_as_custom', {
            order_job_id: this.order_job.id,
            company_id: this.company.id,
            log_by_type: 'App\\Models\\Users\\User',
            log_by_id: this.$store.state.auth.me.id
          })
          // define the lowest level for timesheet authorisation submission level for auth & submit
          let auth_sub_level_start = 2, submit_sub_level_start = 8;
          // save timesheet authorisation & submit contacts
          for (const [i, value] of this.ts_auth.submit_ts.entries()) {
            let ts_auth = {
              company_id: this.company.id,
              order_job_id: this.order_job.id,
              submission_level: submit_sub_level_start,
              contact_id: value.contact.id,
              log_by_type: 'App\\Models\\Users\\User',
              log_by_id: this.$store.state.auth.me.id
            };

            if (value.hasOwnProperty('id')) {
              axios.patch(this.crmApiPath + 'timesheet_authorisation/' + value.id, ts_auth);
            }
            else {
              axios.post(this.crmApiPath + 'timesheet_authorisation', ts_auth);
            }

            //submit_sub_level_start++;
          }
          for (const [i, value] of this.ts_auth.authorising_ts.entries()) {
            let ts_auth = {
              company_id: this.company.id,
              order_job_id: this.order_job.id,
              submission_level: auth_sub_level_start,
              contact_id: value.contact.id,
              log_by_type: 'App\\Models\\Users\\User',
              log_by_id: this.$store.state.auth.me.id
            };

            if (value.hasOwnProperty('id')) {
              axios.patch(this.crmApiPath + 'timesheet_authorisation/' + value.id, ts_auth);
            }
            else {
              axios.post(this.crmApiPath + 'timesheet_authorisation', ts_auth);
            }

            //auth_sub_level_start++;
          }

          setTimeout(() => {
            this.saving_ts_auth = false;
            this.edit_ts_auth = false;
            // this.$nextTick(() => this.$bus.$emit('default_company_ts_auth::reload', {action: true}))
            this.$nextTick(() => this.$tabs.refresh('/order/view', true))
          }, 1000);
        }
      });
    },
  }
}
</script>

<style lang="scss">

.ts_auth_submit {
  .ts_auth_submit_multi {
    width:   calc(100% - 50px);
    display: inline-block;
  }

  .orcaBtn.danger {
    width:       35px;
    height:      35px;
    line-height: 30px;
    padding:     0;
    margin-top:  5px;
  }

  &.first {
    .ts_auth_submit_multi {
      width:   100%;
      display: block;
    }
  }
}

.sm_btn {
  display:     inline-block;
  width:       auto;
  padding:     0 15px;
  line-height: 30px;
  font-size:   0.65rem;
}

.contact_login_text {
  display: inline-block;
  width:   calc(100% - 100px);
}

.contact_login_btn {
  display:    inline-block;
  width:      90px;
  text-align: right;
}

</style>
